import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ntsTypeOptions, otherDeductionsDetailInputList3 } from '../../../common/data';
import { formatNumber } from '../../../common/Util';

import ItemTitleSection from '../../../components/ItemTitleSection';
import TextField from '../../../components/common/TextField';

import Typography from '../../../components/common/Typography';

//투자조합
const Type3 = ({ handleAddButton }) => {
  const { t } = useTranslation('deductions/other');
  const { t: tCommon } = useTranslation('common');
  const { s11_3Data } = useSelector(state => state.otherDeductions);

  const inputFields = otherDeductionsDetailInputList3(t);
  const ntsTypeList = ntsTypeOptions(tCommon);

  const renderField = (field, value, onChange) => {
    let fieldValue = field.isNumber ? formatNumber(value || '') : value?.trim() || '';

    let values = fieldValue;
    if (field.input == 'selectBox') {
      let codeList = [...field?.options];
      const options = codeList.find(item => item.value == fieldValue?.trim());
      values = options?.label || '';
    }

    return (
      <TextField label={field.label} value={values} onChange={() => {}} size="small" disabled />
    );
  };

  return s11_3Data?.length > 0 ? (
    <div className="displayFlexColumn" style={{ gap: '16px' }}>
      <ItemTitleSection
        title={t('detail.type3.title')}
        addButton={true}
        handleAddButton={handleAddButton}
      />

      {s11_3Data?.map((savings, index) => (
        <div key={index} className="savings-item">
          <div className="displayFlexBetween" style={{ marginBottom: '16px' }}>
            <Typography variant="body2Bold">
              {t('detail.type3.title')}
              {index + 1}
            </Typography>
          </div>

          <div className="displayFlexColumn" style={{ gap: '16px' }}>
            {inputFields.map((field, _index) => (
              <div key={_index}>{renderField(field, savings[field.key])}</div>
            ))}
          </div>
        </div>
      ))}
    </div>
  ) : (
    <></>
  );
};

export default Type3;
